// @ts-nocheck
import { createAsyncActionTypes } from '../../../core/store/actionCreators';

export const FETCH_ACTIVITIES = 'activity/fetchActivities';
export const {
  pending: FETCH_ACTIVITIES_PENDING,
  fulfilled: FETCH_ACTIVITIES_FULFILLED,
  rejected: FETCH_ACTIVITIES_REJECTED,
} = createAsyncActionTypes(FETCH_ACTIVITIES);
